export const getPhotovoltaicsReinforcementPrice = (dimensionsData) => {
  const reinforcementData = dimensionsData.find(
    (d) => d["Rozmiar (szer. x dł.)"] === "Wzmocnienie pod fotowoltaikę"
  );

  return reinforcementData
    ? reinforcementData["Cena Netto (zł) zaciagana do konfiguratora"]
    : 0;
};
